import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./FrontWallTable.scss";

const ComponentDataViewModal = React.forwardRef((props, ref) => {
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const {
    additionalComponents,
    canopyRows,
    canopyInputs,
    canopyInputsChange,

    dynamicCanopyRows,
    handleDynomicCanopyInputChange,
    addCanopyColumn,
    deleteCanopyColumn,
    addCanopyRow,
    deleteCanopyRow,

    handleDynamicHeaderChange,
    // Frame Opening
    frameOpeningRows,
    frameOpeningInputs,
    frameOpeningInputsChange,
    dynamicFrameOpening,
    handleDynomicFrameOpeningInputsChange,
    addFrameOpeningColumn,
    handleFrameOpeningDynamicHeaderChange,
    deleteFrameOpeningColumn,
    addFrameOpeningRow,
    deleteFrameOpeningRow,

    // leanToInputs,
    leanToRows,
    deleteLeanToRow,
    addLeanToRow,
    leanToInputs,
    leanToInputsChange,
    dynomicLeanToInputs,
    handleDynomicLeanToInputs,
    addLeanToColumn,
    handleLeanToDynamicHeaderChange,
    deleteLeanToColumn,
    fixedLouversRows,
    dynomicFixedLouversInputs,
    deleteFixedLouversColumn,
    addFixedLouversColumn,
    handleFixedLouversDynamicHeaderChange,
    handleDynomicFixedLouversInputs,
    fixedLouversInputsChange,
    fixedLouversInputs,
    structuralLouversRows,
    structuralLouversInputs,
    structuralLouversInputsChange,
    deleteFixedLouversRow,
    addFixedLouversRow,

    addStructuralLouversColumn,
    handleDynamicStructuralLouversHeaderChange,
    deleteStructuralLouversColumn,
    deleteStructuralLouversRow,
    addStructuralLouversRow,

    dynomicStructuralLouversInputs,
    handleDynomicStructuralLouversInputs,
    fasciaRows,
    fasciaInputs,
    fasciaInputsChange,
    dynomicfasciaInputs,
    handleDynomicfasciaInputs,
    addFasciaColumn,
    handleDynamicFasciaHeaderChange,
    deleteFasciaColumn,
    deleteFasciaRow,
    addFasciaRow,
    InputField,
    onCaseSelect,
    onHide,
    showComponent,
  } = props;

  const handleSave = () => {
    const payload = {
      canopyInputs,
      dynamicCanopyRows,
      frameOpeningInputs,
      dynamicFrameOpening,
      leanToInputs,
      dynomicLeanToInputs,
      dynomicFixedLouversInputs,
      structuralLouversInputs,
      dynomicStructuralLouversInputs,
      fasciaInputs,
      dynomicfasciaInputs,
    };
    if (onCaseSelect) {
      onCaseSelect(payload);
    }
    onHide(); // close modal after saving
  };

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Selected Components Inputs
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="">
          <div className="table-responsive">
            {showComponent?.showComponent === "CANOPY" &&
              additionalComponents?.canopy === true &&
              canopyRows?.length > 0 && (
                <>
                  <span>
                    <h6 className="fw-bold mb-2 mt-3 p-2 text-primary">
                      Canopy Inputs
                    </h6>
                  </span>

                  <div style={{ padding: "20px" }}>
                    <table
                      style={{
                        borderCollapse: "collapse",
                        width: "400px",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Clear height
                          </td>

                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "5px",
                            }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="canopyInputsClearHeight"
                              id="canopyInputsClearHeight"
                              // value={
                              //   canopyInputs?.canopyInputsClearHeight || ""
                              // }
                              // onChange={canopyInputsChange}
                              step={0.001}
                             value={canopyInputs?.canopyInputsClearHeight ?? ""}
                              onChange={(e) => canopyInputsChange({ target: { name: 'canopyInputsClearHeight', value: e.target.value }, formatOnBlur: false })}
                              onBlur={(e) => canopyInputsChange({ target: { name: 'canopyInputsClearHeight', value: e.target.value }, formatOnBlur: true })}
                              style={{
                                width: "100%",
                                boxSizing: "border-box",
                              }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Projection
                          </td>

                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "5px",
                            }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="canopyInputsProjectin"
                              id="canopyInputsProjectin"
                              // value={canopyInputs?.canopyInputsProjectin || ""}
                              // onChange={canopyInputsChange}
                              value={canopyInputs?.canopyInputsProjectin ?? ""}
                              onChange={(e) => canopyInputsChange({ target: { name: 'canopyInputsProjectin', value: e.target.value }, formatOnBlur: false })}
                              onBlur={(e) => canopyInputsChange({ target: { name: 'canopyInputsProjectin', value: e.target.value }, formatOnBlur: true })}
                              style={{
                                width: "100%",
                                boxSizing: "border-box",
                              }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Soffit Sheeting
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="canopyInputsSoftFitSheeting"
                              value={
                                canopyInputs?.canopyInputsSoftFitSheeting || ""
                              }
                              onChange={canopyInputsChange}
                              disabled={props?.disabled}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Gutter
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="canopyInputsGutter"
                              value={canopyInputs?.canopyInputsGutter || ""}
                              onChange={canopyInputsChange}
                              disabled={props?.disabled}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Down take
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="canopyInputsDownTake"
                              value={canopyInputs?.canopyInputsDownTake || ""}
                              onChange={canopyInputsChange}
                              disabled={props?.disabled}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Kicker Pipe
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="canopyInputskickerPipe"
                              value={canopyInputs?.canopyInputskickerPipe || ""}
                              onChange={canopyInputsChange}
                              disabled={props?.disabled}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="sticky bottom-0 left-0 w-full d-flex  justify-content-end align-itmes-start mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addCanopyColumn}
                      disabled={props?.disabled}
                    >
                      + Add Column
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={addCanopyRow}
                      disabled={props?.disabled}
                    >
                      + Add Row
                    </button>
                  </div>

                  {/* Block Wall Conditions Table */}
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Walls</th>
                        <th>Grid Line</th>
                        <th>Bay Spacing</th>
                        <th>Projection</th>
                        <th>Area</th>
                        <th>Clear Height</th>
                        <th>Soffit Sheeting</th>
                        <th>Gutter</th>
                        <th>Down Take</th>
                        <th>Kicker Pipe</th>

                        {props?.activeBuilding?.canopy?.dynamicColumns?.map(
                          (col) => (
                            <th key={col.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control fw-bold"
                                  placeholder="Enter header"
                                  value={col.header}
                                  onChange={(e) =>
                                    handleDynamicHeaderChange(
                                      col.id,
                                      e.target.value
                                    )
                                  }
                                  style={{ flexGrow: 1, marginRight: "5px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger p-1"
                                  onClick={() => deleteCanopyColumn(col.id)}
                                  style={{ height: "30px", width: "30px" }}
                                >
                                  X
                                </button>
                              </div>
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {dynamicCanopyRows?.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wallType || ""}
                              // disabled={true}
                              onChange={(e) =>
                                handleDynomicCanopyInputChange(
                                  i,
                                  "wallType",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wall || ""}
                              onChange={(e) =>
                                handleDynomicCanopyInputChange(
                                  i,
                                  "wall",
                                  e.target.value
                                )
                              }
                              // disabled={true}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.baySpacing || ""}
                              // onChange={(e) =>
                              //   handleDynomicCanopyInputChange(
                              //     i,
                              //     "baySpacing",
                              //     e.target.value
                              //   )
                              // }
                              value={row.baySpacing !== undefined ? row.baySpacing : ""}
  onChange={(e) =>
    handleDynomicCanopyInputChange(i, "baySpacing", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicCanopyInputChange(i, "baySpacing", e.target.value, true)
  }
                              // disabled={props?.disabled}
                            />
                          </td>

                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={
                              //   row.projection
                              //     ? Number(row.projection).toFixed(3)
                              //     : ""
                              // }
                              // onChange={(e) =>
                              //   handleDynomicCanopyInputChange(
                              //     i,
                              //     "projection",
                              //     e.target.value
                              //   )
                              // }
                              value={row.projection !== undefined ? row.projection : ""}
                              onChange={(e) =>
                                  handleDynomicCanopyInputChange(i, "projection", e.target.value)
                               }   
                              onBlur={(e) =>
                                handleDynomicCanopyInputChange(i, "projection", e.target.value, true)
                              }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={
                                row.area ? Number(row.area)?.toFixed(3) : ""
                              }
                              disabled={true}
                            />
                          </td>
                          <td>
                            <InputField
                              type="number"
                              className="form-control form-control-sm"
                              // value={
                              //   row.clearHeight
                              //     ? Number(row.clearHeight)?.toFixed(3)
                              //     : ""
                              // }
                              // onChange={(e) =>
                              //   handleDynomicCanopyInputChange(
                              //     i,
                              //     "clearHeight",
                              //     e.target.value
                              //   )
                              // }
                              value={row.clearHeight !== undefined ? row.clearHeight : ""}
  onChange={(e) =>
    handleDynomicCanopyInputChange(i, "clearHeight", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicCanopyInputChange(i, "clearHeight", e.target.value, true)
  }

                              disabled={props?.disabled}
                            />
                          </td>

                          <td>
                            <select
                              value={row.softFitSheething || ""} // Just use the row value
                              onChange={(e) =>
                                handleDynomicCanopyInputChange(
                                  i,
                                  "softFitSheething",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          <td>
                            <select
                              value={row.gutter || ""} // Just use the row value
                              onChange={(e) =>
                                handleDynomicCanopyInputChange(
                                  i,
                                  "gutter",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          <td>
                            <select
                              value={row.downTake || ""} // Just use the row value
                              onChange={(e) =>
                                handleDynomicCanopyInputChange(
                                  i,
                                  "downTake",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          <td>
                            <select
                              value={row.kickerPipe || ""} // Just use the row value
                              onChange={(e) =>
                                handleDynomicCanopyInputChange(
                                  i,
                                  "kickerPipe",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
             
                          {props?.activeBuilding?.canopy?.dynamicColumns?.map(
                            (col) => (
                              <td key={col.id}>
                                <InputField
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={row[col.key] || ""}
                                  onChange={(e) =>
                                    handleDynomicCanopyInputChange(
                                      i,
                                      col.key,
                                      e.target.value
                                    )
                                  }
                                  disabled={props?.disabled}
                                />
                              </td>
                            )
                          )}

                          <td>
                            {row.isManual && (
                              /* Only allow deletion of manually added rows */
                              <button
                                type="button"
                                className="btn btn-sm btn-danger p-1"
                                onClick={() => deleteCanopyRow(i)}
                                disabled={props?.disabled}
                                style={{ height: "30px", width: "30px" }}
                              >
                                -
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <spna className="fw-medium text-black">
                      {" "}
                      SubTotal - Area :{" "}
                    </spna>{" "}
                    {dynamicCanopyRows
                      ?.reduce((sum, row) => sum + (row.area || 0), 0)
                      ?.toFixed(3)}
                  </p>
                </>
              )}

            {/* Frame Opening */}
            {showComponent?.showComponent === "FRAMEOPENING" &&
              additionalComponents?.frameOpening === true &&
              frameOpeningRows?.length > 0 && (
                <>
                  <h6 className="fw-bold mb-2 mt-3 p-2 text-primary">
                    Frame Opening Inputs
                  </h6>

                  <div style={{ padding: "20px" }}>
                    <table
                      style={{ borderCollapse: "collapse", width: "400px" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Width
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
  className="inputBox"
  type="number"
  name="frameOpeningInputsWidth"
  id="frameOpeningInputsWidth"
  value={frameOpeningInputs?.frameOpeningInputsWidth ?? ""}
  onChange={(e) => frameOpeningInputsChange({ target: { name: 'frameOpeningInputsWidth', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => frameOpeningInputsChange({ target: { name: 'frameOpeningInputsWidth', value: e.target.value }, formatOnBlur: true })}
  style={{ width: "100%", boxSizing: "border-box" }}
  disabled={props?.disabled}
/>
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Height
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
  className="inputBox"
  type="number"
  name="frameOpeningInputsHeight"
  id="frameOpeningInputsHeight"
  value={frameOpeningInputs?.frameOpeningInputsHeight ?? ""}
  onChange={(e) => frameOpeningInputsChange({ target: { name: 'frameOpeningInputsHeight', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => frameOpeningInputsChange({ target: { name: 'frameOpeningInputsHeight', value: e.target.value }, formatOnBlur: true })}
  style={{ width: "100%", boxSizing: "border-box" }}
  disabled={props?.disabled}
/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Add Column Button */}
                  <div className="sticky bottom-0 left-0 w-full d-flex justify-content-end align-items-start mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addFrameOpeningColumn}
                      disabled={props?.disabled}
                    >
                      + Add Column
                    </button>

                    <button
                      type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={addFrameOpeningRow}
                      disabled={props?.disabled}
                    >
                      + Add Row
                    </button>
                  </div>

                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Walls</th>
                        <th>Grid Line</th>
                        <th>Bay Spacing</th>
                        <th>Width</th>
                        <th>Height</th>
                        <th>Area</th>

                        {/* Dynamic Columns */}
                        {props?.activeBuilding?.frameOpening?.dynamicColumns?.map(
                          (col) => (
                            <th key={col.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control fw-bold"
                                  placeholder="Enter header"
                                  value={col.header}
                                  onChange={(e) =>
                                    handleFrameOpeningDynamicHeaderChange(
                                      col.id,
                                      e.target.value
                                    )
                                  }
                                  style={{ flexGrow: 1, marginRight: "5px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger p-1"
                                  onClick={() =>
                                    deleteFrameOpeningColumn(col.id)
                                  }
                                  style={{ height: "30px", width: "30px" }}
                                >
                                  X
                                </button>
                              </div>
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {frameOpeningRows?.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wallType}
                              onChange={(e) =>
                                handleDynomicFrameOpeningInputsChange(
                                  i,
                                  "wallType",
                                  e.target.value
                                )
                              }
                              // disabled={true}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wall}
                              onChange={(e) =>
                                handleDynomicFrameOpeningInputsChange(
                                  i,
                                  "wall",
                                  e.target.value
                                )
                              }
                              // disabled={true}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.baySpacing}
                              // onChange={(e) =>
                              //   handleDynomicFrameOpeningInputsChange(
                              //     i,
                              //     "baySpacing",
                              //     e.target.value
                              //   )
                              // }
                              value={row.baySpacing !== undefined ? row.baySpacing : ""}
  onChange={(e) =>
    handleDynomicFrameOpeningInputsChange(i, "baySpacing", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicFrameOpeningInputsChange(i, "baySpacing", e.target.value, true)
  }
                              // disabled={props?.disabled}
                            />
                          </td>
                          {/* <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={
                                row.width ? Number(row.width)?.toFixed(3) : ""
                              }
                              onChange={(e) =>
                                handleDynomicFrameOpeningInputsChange(
                                  i,
                                  "width",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="number"
                              className="form-control form-control-sm"
                              value={
                                row.height ? Number(row.height)?.toFixed(3) : ""
                              }
                              onChange={(e) =>
                                handleDynomicFrameOpeningInputsChange(
                                  i,
                                  "height",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                            />
                          </td> */}
<td>
<InputField
  type="number"
  className="form-control form-control-sm"
  value={row.width !== undefined ? row.width : ""}
  onChange={(e) =>
    handleDynomicFrameOpeningInputsChange(i, "width", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicFrameOpeningInputsChange(i, "width", e.target.value, true)
  }
  disabled={props?.disabled}
/>
</td>
<td>
<InputField
  type="number"
  className="form-control form-control-sm"
  value={row.height !== undefined ? row.height : ""}
  onChange={(e) =>
    handleDynomicFrameOpeningInputsChange(i, "height", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicFrameOpeningInputsChange(i, "height", e.target.value, true)
  }
  disabled={props?.disabled}
/>
</td>

                          <td>
                            <InputField
                              type="number"
                              className="form-control form-control-sm"
                              value={
                                row.area ? Number(row.area)?.toFixed(3) : ""
                              }
                              disabled={true}
                            />
                          </td>

                          {/* Dynamic Column Cells */}
                          {props?.activeBuilding?.frameOpening?.dynamicColumns?.map(
                            (col) => (
                              <td key={col.id}>
                                <InputField
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={row[col.key] || ""}
                                  onChange={(e) =>
                                    handleDynomicFrameOpeningInputsChange(
                                      i,
                                      col.key,
                                      e.target.value
                                    )
                                  }
                                  disabled={props?.disabled}
                                />
                              </td>
                            )
                          )}
                          <td>
                            {row.isManual && (
                              /* Only allow deletion of manually added rows */
                              <button
                                type="button"
                                className="btn btn-sm btn-danger p-1"
                                onClick={() => deleteFrameOpeningRow(i)}
                                disabled={props?.disabled}
                                style={{ height: "30px", width: "30px" }}
                              >
                                -
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <span className="fw-medium text-black">
                      SubTotal - Area :{" "}
                    </span>
                    {frameOpeningRows
                      ?.reduce((sum, row) => sum + (row.area || 0), 0)
                      ?.toFixed(3)}
                  </p>
                </>
              )}
            {showComponent?.showComponent === "LEANTO" &&
              additionalComponents?.leanTo === true &&
              leanToRows?.length > 0 && (
                <>
                  <h6 className="fw-bold mb-2 mt-3 p-2 text-primary">
                    Lean To Inputs
                  </h6>

                  {/* Lean To Input Fields */}
                  <div style={{ padding: "20px" }}>
                    <table
                      style={{ borderCollapse: "collapse", width: "400px" }}
                    >
                      <tbody>
                        {[
                          { label: "Width", name: "leanToInputsWidth" },
                          {
                            label: "Clear height",
                            name: "leanToInputsClearHight",
                          },
                          {
                            label: "Block Wall",
                            name: "leanToInputsBlockWall",
                          },
                          { label: "Slope", name: "leanToInputsSlope" },
                        ].map((field, idx) => (
                          <tr key={idx}>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              {field.label}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "5px",
                              }}
                            >
                              <InputField
                                className="inputBox"
                                type="number"
                                name={field.name}
                                id={field.name}
                                // value={leanToInputs?.[field.name] || ""}
                                // onChange={leanToInputsChange}
                                value={leanToInputs?.[field.name] || ""}
        onChange={(e) =>
          leanToInputsChange({
            target: { name: field.name, value: e.target.value },
            formatOnBlur: false,
          })
        }
        onBlur={(e) =>
          leanToInputsChange({
            target: { name: field.name, value: e.target.value },
            formatOnBlur: true,
          })
        }
                               style={{
                                  width: "100%",
                                  boxSizing: "border-box",
                                }}
                                disabled={props?.disabled}
                              />
                            </td>
                          </tr>
                        ))}

                        {/* Down take */}
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Down take
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="leanToInputsDowntake"
                              value={leanToInputs?.leanToInputsDowntake || ""}
                              onChange={leanToInputsChange}
                              disabled={props?.disabled}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>

                        {/* Apron */}
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Apron
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="leanToInputsApron"
                              value={leanToInputs?.leanToInputsApron || ""}
                              onChange={leanToInputsChange}
                              disabled={props?.disabled}
                            >
                              {/* <option value="">Apron</option> */}
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>

                        {/* Gutter */}
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Gutter
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="leanToInputsGutter"
                              value={leanToInputs?.leanToInputsGutter || ""}
                              onChange={leanToInputsChange}
                              disabled={props?.disabled}
                            >
                              {/* <option value="">Select Gutter</option> */}
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>

                        {/* Girt Condition */}
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Girt condition
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="leanToInputsGirtcondition"
                              value={
                                leanToInputs?.leanToInputsGirtcondition || ""
                              }
                              onChange={leanToInputsChange}
                              disabled={props?.disabled}
                            >
                              {/* <option value="">Select Girt Condition</option> */}
                              <option value="Bypass">Bypass</option>
                              <option value="Flush">Flush</option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Sticky Button Bar */}
                  <div className="sticky bottom-0 left-0 w-full flex justify-end items-start mb-2 ">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addLeanToColumn}
                      disabled={props?.disabled}
                    >
                      + Add Column
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={addLeanToRow}
                      disabled={props?.disabled}
                    >
                      + Add Row
                    </button>
                  </div>

                  {/* Lean To Dynamic Table */}
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Walls</th>
                        <th>Grid Line</th>
                        <th>Bay Spacing</th>
                        {/* <th>Length</th> */}
                        <th>Width</th>
                        <th>Clear Height</th>
                        <th>Block Wall</th>
                        <th>Area</th>
                        <th>Down Take</th>
                        <th>Apron</th>
                        <th>Gutter</th>
                        <th>Girts Condition</th>

                        {/* Dynamic Columns */}
                        {props?.activeBuilding?.leanTo?.dynamicColumns?.map(
                          (col) => (
                            <th key={col.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control fw-bold"
                                  placeholder="Enter header"
                                  value={col.header}
                                  onChange={(e) =>
                                    handleLeanToDynamicHeaderChange(
                                      col.id,
                                      e.target.value
                                    )
                                  }
                                  style={{ flexGrow: 1, marginRight: "5px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger p-1"
                                  onClick={() => deleteLeanToColumn(col.id)}
                                  style={{ height: "30px", width: "30px" }}
                                >
                                  X
                                </button>
                              </div>
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {leanToRows?.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wallType}
                              // disabled={true}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "wallType",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wall}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "wall",
                                  e.target.value
                                )
                              }
                              // disabled={true}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.baySpacing}
                              // onChange={(e) =>
                              //   handleDynomicLeanToInputs(
                              //     i,
                              //     "baySpacing",
                              //     e.target.value
                              //   )
                              // }
                              value={row.baySpacing !== undefined ? row.baySpacing : ""}
  onChange={(e) =>
    handleDynomicLeanToInputs(i, "baySpacing", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicLeanToInputs(i, "baySpacing", e.target.value, true)
  }
                              // disabled={props?.disabled}
                            />
                          </td>
                          {/* <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.length}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "length",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                            />
                          </td> */}
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                            // value={
                            //   row.width ? Number(row.width)?.toFixed(3) : ""
                            // }
                            //   onChange={(e) =>
                            //     handleDynomicLeanToInputs(
                            //       i,
                            //       "width",
                            //       e.target.value
                            //     )
                            //   }
                              value={row.width !== undefined ? row.width : ""}
  onChange={(e) =>
    handleDynomicLeanToInputs(i, "width", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicLeanToInputs(i, "width", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={
                              //   row.clearHeight
                              //     ? Number(row.clearHeight)?.toFixed(3)
                              //     : ""
                              // }
                              // onChange={(e) =>
                              //   handleDynomicLeanToInputs(
                              //     i,
                              //     "clearHeight",
                              //     e.target.value
                              //   )
                              // }
                              value={row.clearHeight !== undefined ? row.clearHeight : ""}
  onChange={(e) =>
    handleDynomicLeanToInputs(i, "clearHeight", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicLeanToInputs(i, "clearHeight", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.blockWall ? Number(row.blockWall)?.toFixed(3) : ""}
                              // onChange={(e) =>
                              //   handleDynomicLeanToInputs(
                              //     i,
                              //     "blockWall",
                              //     e.target.value
                              //   )
                              // }
                              value={row.blockWall !== undefined ? row.blockWall : ""}
  onChange={(e) =>
    handleDynomicLeanToInputs(i, "blockWall", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicLeanToInputs(i, "blockWall", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.area}
                              value={
                                row.area ? Number(row.area)?.toFixed(3) : ""
                              }
                              disabled={true}
                            />
                          </td>
                          <td>
                            <select
                              value={row.downTake || ""}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "downTake",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              {/* <option value="">Down take</option> */}
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          <td>
                            <select
                              value={row.apron || ""}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "apron",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              {/* <option value="">Apron</option> */}
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          <td>
                            <select
                              value={row.gutter || ""}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "gutter",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              {/* <option value="">Gutter</option> */}
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          <td>
                            <select
                              value={row.girtCondition || ""}
                              onChange={(e) =>
                                handleDynomicLeanToInputs(
                                  i,
                                  "girtCondition",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              {/* <option value="">Select Condition</option> */}
                              <option value="Bypass">Bypass</option>
                              <option value="Flush">Flush</option>
                            </select>
                          </td>

                          {/* Dynamic Column Cells */}
                          {props?.activeBuilding?.leanTo?.dynamicColumns?.map(
                            (col) => (
                              <td key={col.id}>
                                <InputField
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={row[col.key] || ""}
                                  onChange={(e) =>
                                    handleDynomicLeanToInputs(
                                      i,
                                      col.key,
                                      e.target.value
                                    )
                                  }
                                  disabled={props?.disabled}
                                />
                              </td>
                            )
                          )}
                          <td>
                            {row.isManual && (
                              /* Only allow deletion of manually added rows */
                              <button
                                type="button"
                                className="btn btn-sm btn-danger p-1"
                                onClick={() => deleteLeanToRow(i)}
                                disabled={props?.disabled}
                                style={{ height: "30px", width: "30px" }}
                              >
                                -
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <span className="fw-medium text-black">
                      SubTotal - Area :{" "}
                    </span>
                    {leanToRows
                      ?.reduce((sum, row) => sum + (row.area || 0), 0)
                      .toFixed(3)}
                  </p>
                </>
              )}

            {showComponent?.showComponent === "FIXEDLOUVERS" &&
              additionalComponents?.fixedLouvers === true &&
              fixedLouversRows?.length > 0 && (
                <>
                  <h6 className="fw-bold mb-2 mt-3 p-2 text-primary">
                    Fixed Louvers Inputs
                  </h6>

                  <div style={{ padding: "20px" }}>
                    <table
                      style={{ borderCollapse: "collapse", width: "400px" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Type
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                         
                            <select
                              className="form-control"
                              name="type"
                              value={fixedLouversInputs?.type || ""}
                              onChange={fixedLouversInputsChange}
                              // disabled={props?.disabled}
                            >
                              {/* <option value="">Select Girt Condition</option> */}
                              <option value="Partially">Partially</option>
                              <option value="Continuous">Continuous</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Width
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="width"
                              // value={fixedLouversInputs?.width || ""}
                              // onChange={fixedLouversInputsChange}
                              value={fixedLouversInputs?.width ?? ""}
  onChange={(e) => fixedLouversInputsChange({ target: { name: 'width', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => fixedLouversInputsChange({ target: { name: 'width', value: e.target.value }, formatOnBlur: true })}
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Height
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="height"
                              // value={
                              //   fixedLouversInputs?.height || ""
                              // }
                              // onChange={fixedLouversInputsChange}
                               value={fixedLouversInputs?.height ?? ""}
  onChange={(e) => fixedLouversInputsChange({ target: { name: 'height', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => fixedLouversInputsChange({ target: { name: 'height', value: e.target.value }, formatOnBlur: true })}
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Quantity
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="quantity"
                              // value={
                              //   fixedLouversInputs?.quantity || ""
                              // }
                              // onChange={fixedLouversInputsChange}
                              value={fixedLouversInputs?.quantity ?? ""}
  onChange={(e) => fixedLouversInputsChange({ target: { name: 'quantity', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => fixedLouversInputsChange({ target: { name: 'quantity', value: e.target.value }, formatOnBlur: true })}
  step={1}                            
  style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Add Column Button */}
                  <div className="sticky bottom-0 left-0 w-full d-flex justify-content-end align-items-start mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addFixedLouversColumn}
                      disabled={props?.disabled}
                    >
                      + Add Column
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={addFixedLouversRow}
                      disabled={props?.disabled}
                    >
                      + Add Row
                    </button>
                  </div>

                  {/* Fixed Louvers Table with Area Column */}
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Walls</th>
                        <th>Grid Line</th>
                        <th>Type</th>
                        <th>Width</th>
                        <th>Height</th>
                        <th>Quantity</th>
                        <th>Area</th>

                        {/* Dynamic Columns */}
                        {props?.activeBuilding?.fixedLouvers?.dynamicColumns?.map(
                          (col) => (
                            <th key={col.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control fw-bold"
                                  placeholder="Enter header"
                                  value={col.header}
                                  onChange={(e) =>
                                    handleFixedLouversDynamicHeaderChange(
                                      col.id,
                                      e.target.value
                                    )
                                  }
                                  style={{ flexGrow: 1, marginRight: "5px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger p-1"
                                  onClick={() =>
                                    deleteFixedLouversColumn(col.id)
                                  }
                                  style={{ height: "30px", width: "30px" }}
                                >
                                  X
                                </button>
                              </div>
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {fixedLouversRows?.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wallType}
                              onChange={(e) =>
                                handleDynomicFixedLouversInputs(
                                  i,
                                  "wallType",
                                  e.target.value
                                )
                              }
                              // disabled={true}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wall}
                              onChange={(e) =>
                                handleDynomicFixedLouversInputs(
                                  i,
                                  "wall",
                                  e.target.value
                                )
                              }
                              // disabled={true}
                            />
                          </td>
                          <td>
                            <select
                              className="form-control form-control-sm"
                              name="type"
                              value={row.type}
                              onChange={(e) =>
                                handleDynomicFixedLouversInputs(
                                  i,
                                  "type",
                                  e.target.value
                                )
                              }
                            >
                              {/* <option value="">Select Girt Condition</option> */}
                              <option value="Partially">Partially</option>
                              <option value="Continuous">Continuous</option>
                            </select>
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={
                              //   row.width ? Number(row.width)?.toFixed(3) : ""
                              // }
                              // onChange={(e) =>
                              //   handleDynomicFixedLouversInputs(
                              //     i,
                              //     "width",
                              //     e.target.value
                              //   )
                              // }
                              value={row.width !== undefined ? row.width : ""}
  onChange={(e) =>
    handleDynomicFixedLouversInputs(i, "width", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicFixedLouversInputs(i, "width", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={
                              //   row.height ? Number(row.height)?.toFixed(3) : ""
                              // }
                              // onChange={(e) =>
                              //   handleDynomicFixedLouversInputs(
                              //     i,
                              //     "height",
                              //     e.target.value
                              //   )
                              // }
                              value={row.height !== undefined ? row.height : ""}
  onChange={(e) =>
    handleDynomicFixedLouversInputs(i, "height", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicFixedLouversInputs(i, "height", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.quantity ? Number(row.quantity)?.toFixed(0) : ""}
                              // onChange={(e) =>
                              //   handleDynomicFixedLouversInputs(
                              //     i,
                              //     "quantity",
                              //     e.target.value
                              //   )
                              // }
                              step={1}
                              value={row.quantity !== undefined ? row.quantity : ""}
  onChange={(e) =>
    handleDynomicFixedLouversInputs(i, "quantity", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicFixedLouversInputs(i, "quantity", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            {/* Area column - read only */}
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.area || ""}
                              value={
                                row.area ? Number(row.area)?.toFixed(3) : ""
                              }
                              disabled={true}
                              readOnly
                            />
                          </td>

                          {/* Dynamic Column Cells */}
                          {props?.activeBuilding?.fixedLouvers?.dynamicColumns?.map(
                            (col) => (
                              <td key={col.id}>
                                <InputField
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={row[col.key] || ""}
                                  onChange={(e) =>
                                    handleDynomicFixedLouversInputs(
                                      i,
                                      col.key,
                                      e.target.value
                                    )
                                  }
                                  disabled={props?.disabled}
                                />
                              </td>
                            )
                          )}
                          <td>
                            {row.isManual && (
                              /* Only allow deletion of manually added rows */
                              <button
                                type="button"
                                className="btn btn-sm btn-danger p-1"
                                onClick={() => deleteFixedLouversRow(i)}
                                disabled={props?.disabled}
                                style={{ height: "30px", width: "30px" }}
                              >
                                -
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <span className="fw-medium text-black">
                      SubTotal - Area :{" "}
                    </span>
                    {fixedLouversRows?.reduce(
                      (sum, row) => sum + (row.area || 0),
                      0
                    ).toFixed(3)}
                  </p>
                </>
              )}

            {showComponent?.showComponent === "STRUCTURALLOUVERS" &&
              additionalComponents?.structuralLouvers === true &&
              structuralLouversRows?.length > 0 && (
                <>
                  <h6 className="fw-bold mb-2 mt-3 p-2 text-primary">
                    Structural Louvers Inputs
                  </h6>
                  <div style={{ padding: "20px" }}>
                    <table
                      style={{ borderCollapse: "collapse", width: "400px" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Projection
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              type="number"
                              name="structuralLouversInputsProjectin"
                              id="structuralLouversInputsProjectin"
                              className="inputBox"
                              // value={
                              //   structuralLouversInputs?.structuralLouversInputsProjectin ||
                              //   ""
                              // }
                              // onChange={structuralLouversInputsChange}
                              value={structuralLouversInputs?.structuralLouversInputsProjectin ?? ""}
  onChange={(e) => structuralLouversInputsChange({ target: { name: 'structuralLouversInputsProjectin', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => structuralLouversInputsChange({ target: { name: 'structuralLouversInputsProjectin', value: e.target.value }, formatOnBlur: true })}
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Height
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              type="number"
                              className="inputBox"
                              name="structuralLouversInputsHeight"
                              id="structuralLouversInputsHeight"
                              // value={
                              //   structuralLouversInputs?.structuralLouversInputsHeight ||
                              //   ""
                              // }
                              // onChange={structuralLouversInputsChange}
                              value={structuralLouversInputs?.structuralLouversInputsHeight ?? ""}
  onChange={(e) => structuralLouversInputsChange({ target: { name: 'structuralLouversInputsHeight', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => structuralLouversInputsChange({ target: { name: 'structuralLouversInputsHeight', value: e.target.value }, formatOnBlur: true })}
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Mesh
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <select
                              className="form-control"
                              name="structuralLouversInputsMesh"
                              value={
                                structuralLouversInputs?.structuralLouversInputsMesh ||
                                ""
                              }
                              onChange={structuralLouversInputsChange}
                              disabled={props?.disabled}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            No of fins
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              type="number"
                              className="inputBox"
                              name="structuralLouversInputsNoOffins"
                              id="structuralLouversInputsNoOffins"
                              // value={
                              //   structuralLouversInputs?.structuralLouversInputsNoOffins ||
                              //   ""
                              // }
                              // onChange={structuralLouversInputsChange}
                               value={structuralLouversInputs?.structuralLouversInputsNoOffins ?? ""}
  onChange={(e) => structuralLouversInputsChange({ target: { name: 'structuralLouversInputsNoOffins', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => structuralLouversInputsChange({ target: { name: 'structuralLouversInputsNoOffins', value: e.target.value }, formatOnBlur: true })}
  step={1}   
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="sticky bottom-0 left-0 w-full d-flex justify-content-end align-itmes-start mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addStructuralLouversColumn}
                      disabled={props?.disabled}
                    >
                      + Add Column
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={addStructuralLouversRow}
                      disabled={props?.disabled}
                    >
                      + Add Row
                    </button>
                  </div>

                  {/* Block Wall Conditions Table */}
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Walls</th>
                        <th>Grid Line</th>
                        <th>Bay Spacing</th>
                        <th>Projection</th>
                        <th>Height</th>
                        <th>No of Fins</th>
                        <th>Mesh</th>
                        {props?.activeBuilding?.structuralLouvers?.dynamicColumns?.map(
                          (col) => (
                            <th key={col.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control fw-bold"
                                  placeholder="Enter header"
                                  value={col.header}
                                  onChange={(e) =>
                                    handleDynamicStructuralLouversHeaderChange(
                                      col.id,
                                      e.target.value
                                    )
                                  }
                                  style={{ flexGrow: 1, marginRight: "5px" }}
                                />
                                {/* Delete Button */}
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger p-1"
                                  onClick={() =>
                                    deleteStructuralLouversColumn(col.id)
                                  }
                                  disabled={props?.disabled}
                                  style={{
                                    height: "30px",
                                    width: "30px",
                                    flexShrink: 0,
                                  }}
                                >
                                  X
                                </button>
                              </div>
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {dynomicStructuralLouversInputs.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wallType}
                              onChange={(e) =>
                                handleDynomicStructuralLouversInputs(
                                  i,
                                  "wallType",
                                  e.target.value
                                )
                              }
                              // disabled
                            />
                          </td>

                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wall}
                              onChange={(e) =>
                                handleDynomicStructuralLouversInputs(
                                  i,
                                  "wall",
                                  e.target.value
                                )
                              }
                              // disabled
                            />
                          </td>

                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.baySpacing}
                              // onChange={(e) =>
                              //   handleDynomicStructuralLouversInputs(
                              //     i,
                              //     "baySpacing",
                              //     e.target.value
                              //   )
                              // }
                              value={row.baySpacing !== undefined ? row.baySpacing : ""}
  onChange={(e) =>
    handleDynomicStructuralLouversInputs(i, "baySpacing", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicStructuralLouversInputs(i, "baySpacing", e.target.value, true)
  }
                              // disabled={props?.disabled}
                            />
                          </td>

                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.projectin ? Number(row.projectin)?.toFixed(3) : ""}
                              // onChange={(e) =>
                              //   handleDynomicStructuralLouversInputs(
                              //     i,
                              //     "projectin",
                              //     e.target.value
                              //   )
                              // }
                              value={row.projectin !== undefined ? row.projectin : ""}
  onChange={(e) =>
    handleDynomicStructuralLouversInputs(i, "projectin", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicStructuralLouversInputs(i, "projectin", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>

                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.height ? Number(row.height)?.toFixed(3) : ""}
                              // onChange={(e) =>
                              //   handleDynomicStructuralLouversInputs(
                              //     i,
                              //     "height",
                              //     e.target.value
                              //   )
                              // }
                              value={row.height !== undefined ? row.height : ""}
  onChange={(e) =>
    handleDynomicStructuralLouversInputs(i, "height", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicStructuralLouversInputs(i, "height", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>

                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.noOfFins}
                              // onChange={(e) =>
                              //   handleDynomicStructuralLouversInputs(
                              //     i,
                              //     "noOfFins",
                              //     e.target.value
                              //   )
                              // }
                              step={1}
                              value={row.noOfFins !== undefined ? row.noOfFins : ""}
  onChange={(e) =>
    handleDynomicStructuralLouversInputs(i, "noOfFins", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicStructuralLouversInputs(i, "noOfFins", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <select
                              value={row.mesh || ""} // Just use the row value
                              onChange={(e) =>
                                handleDynomicStructuralLouversInputs(
                                  i,
                                  "mesh",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          {props?.activeBuilding?.structuralLouvers?.dynamicColumns?.map(
                            (col) => (
                              <td key={col.key}>
                                <InputField
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={row[col.key] || ""}
                                  onChange={(e) =>
                                    handleDynomicStructuralLouversInputs(
                                      i,
                                      col.key,
                                      e.target.value
                                    )
                                  }
                                  disabled={props?.disabled}
                                />
                              </td>
                            )
                          )}
                          <td>
                            {row.isManual && (
                              /* Only allow deletion of manually added rows */
                              <button
                                type="button"
                                className="btn btn-sm btn-danger p-1"
                                onClick={() => deleteStructuralLouversRow(i)}
                                disabled={props?.disabled}
                                style={{ height: "30px", width: "30px" }}
                              >
                                -
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

            {showComponent?.showComponent === "FASCIA" &&
              additionalComponents?.fascia === true &&
              fasciaRows?.length > 0 && (
                <>
                  <h6 className="fw-bold mb-2 mt-3 p-2 text-primary">
                    Fascia Inputs
                  </h6>
                  <div style={{ padding: "20px" }}>
                    <table
                      style={{ borderCollapse: "collapse", width: "400px" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Height
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="fasciaInputsHeight"
                              // value={fasciaInputs?.fasciaInputsHeight || ""}
                              // onChange={fasciaInputsChange}
                              value={fasciaInputs?.fasciaInputsHeight ?? ""}
  onChange={(e) => fasciaInputsChange({ target: { name: 'fasciaInputsHeight', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => fasciaInputsChange({ target: { name: 'fasciaInputsHeight', value: e.target.value }, formatOnBlur: true })}
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Sheeting
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "5px" }}
                          >
                            <InputField
                              className="inputBox"
                              type="number"
                              name="fasciaInputsSheeting"
                              // value={fasciaInputs?.fasciaInputsSheeting || ""}
                              // onChange={fasciaInputsChange}
                              value={fasciaInputs?.fasciaInputsSheeting ?? ""}
  onChange={(e) => fasciaInputsChange({ target: { name: 'fasciaInputsSheeting', value: e.target.value }, formatOnBlur: false })}
  onBlur={(e) => fasciaInputsChange({ target: { name: 'fasciaInputsSheeting', value: e.target.value }, formatOnBlur: true })}
                              
                              style={{ width: "100%", boxSizing: "border-box" }}
                              disabled={props?.disabled}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="sticky bottom-0 left-0 w-full d-flex justify-content-end items-start mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addFasciaColumn}
                      disabled={props?.disabled}
                    >
                      + Add Column
                    </button>

                    <button
                      type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={addFasciaRow}
                      disabled={props?.disabled}
                    >
                      + Add Row
                    </button>
                  </div>
                  {/* Fascia Table */}
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Walls</th>
                        <th>Grid Line</th>
                        <th>Bay Spacing</th>
                        <th>Height</th>
                        <th>Area</th>
                        <th>Purlin/Condition</th>
                        {props?.activeBuilding?.fascia?.dynamicColumns?.map(
                          (col) => (
                            <th key={col.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control fw-bold"
                                  placeholder="Enter header"
                                  value={col.header}
                                  onChange={(e) =>
                                    handleDynamicFasciaHeaderChange(
                                      col.id,
                                      e.target.value
                                    )
                                  }
                                  style={{ flexGrow: 1, marginRight: "5px" }}
                                />
                                {/* Delete Button */}
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger p-1"
                                  onClick={() => deleteFasciaColumn(col.id)}
                                  disabled={props?.disabled}
                                  style={{
                                    height: "30px",
                                    width: "30px",
                                    flexShrink: 0,
                                  }}
                                >
                                  X
                                </button>
                              </div>
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {dynomicfasciaInputs?.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wallType}
                              onChange={(e) =>
                                handleDynomicfasciaInputs(
                                  i,
                                  "wallType",
                                  e.target.value
                                )
                              }
                              // disabled
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              value={row.wall}
                              onChange={(e) =>
                                handleDynomicfasciaInputs(
                                  i,
                                  "wall",
                                  e.target.value
                                )
                              }
                              // disabled
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.baySpacing}
                              // onChange={(e) =>
                              //   handleDynomicfasciaInputs(
                              //     i,
                              //     "baySpacing",
                              //     e.target.value
                              //   )
                              // }
                              value={row.baySpacing !== undefined ? row.baySpacing : ""}
  onChange={(e) =>
    handleDynomicfasciaInputs(i, "baySpacing", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicfasciaInputs(i, "baySpacing", e.target.value, true)
  }
                              // disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.height ? Number(row.height)?.toFixed(3) : ""}
                              // onChange={(e) =>
                              //   handleDynomicfasciaInputs(
                              //     i,
                              //     "height",
                              //     e.target.value
                              //   )
                              // }
                              value={row.height !== undefined ? row.height : ""}
  onChange={(e) =>
    handleDynomicfasciaInputs(i, "height", e.target.value)
  }
  onBlur={(e) =>
    handleDynomicfasciaInputs(i, "height", e.target.value, true)
  }
                              disabled={props?.disabled}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              className="form-control form-control-sm"
                              // value={row.area}
                              value={row.area ? Number(row.area)?.toFixed(3) : ""}
                              disabled={true}
                            />
                          </td>
                          <td>
                            <select
                              value={row.purlinCondition || ""}
                              onChange={(e) =>
                                handleDynomicfasciaInputs(
                                  i,
                                  "purlinCondition",
                                  e.target.value
                                )
                              }
                              disabled={props?.disabled}
                              className={`w-full px-2 py-1 border rounded-md ${
                                props?.disabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              <option value="Bypass">Bypass</option>
                              <option value="Flush">Flush</option>
                            </select>
                          </td>
                          {props?.activeBuilding?.fascia?.dynamicColumns?.map(
                            (col) => (
                              <td key={col.key}>
                                <InputField
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={row[col.key] || ""}
                                  onChange={(e) =>
                                    handleDynomicfasciaInputs(
                                      i,
                                      col.key,
                                      e.target.value
                                    )
                                  }
                                  disabled={props?.disabled}
                                />
                              </td>
                            )
                          )}
                          <td style={{ width: "10px" }}>
                            {row.isManual && (
                              /* Only allow deletion of manually added rows */
                              <button
                                type="button"
                                className="btn btn-sm btn-danger p-1"
                                onClick={() => deleteFasciaRow(i)}
                                disabled={props?.disabled}
                                style={{ height: "30px", width: "30px" }}
                              >
                                -
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <spna className="fw-medium text-black">
                      {" "}
                      SubTotal - Area :{" "}
                    </spna>{" "}
                    {dynomicfasciaInputs?.reduce(
                      (sum, row) => sum + (row.area || 0),
                      0
                    ).toFixed(3)}
                  </p>{" "}
                </>
              )}
          </div>
        </Modal.Body>

        {/* Save and cancel  */}
        {!props?.disabled && (
          <Modal.Footer>
            <button className="btn btn-danger" onClick={onHide}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSave}>
              Save
            </button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
});

export default ComponentDataViewModal;

